import classnames from 'classnames';
import React from 'react';

import TRANSLATIONS from './translations@default.json';

const HighDemandFlag = ({ classes }) => (
	<div
		className={classnames(
			classes,
			'bg-highlight font-bold p-2 rounded text-body-xs text-center text-primary mt-4'
		)}>
		{TRANSLATIONS.title}
	</div>
);

export default HighDemandFlag;
